(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pmc-popular-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pmc-popular-products')) {
    class PmcPopularProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-pmc-popular-load-more]');
          if (button && this.contains(button)) this.loadMore(button);
        });
      }

      async loadMore(button) {
        const nextUrl = button.dataset.nextUrl;
        if (!nextUrl || button.dataset.loading === 'true') return;

        const label = button.querySelector('[data-pmc-popular-button-label]');
        const status = this.querySelector('[data-pmc-popular-status]');
        const defaultLabel = button.dataset.defaultLabel;

        button.dataset.loading = 'true';
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');
        label.textContent = button.dataset.loadingLabel;

        try {
          const response = await fetch(nextUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) throw new Error('Popular products request failed');

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = parsed.querySelector('[data-pmc-popular-items]');
          const currentGrid = this.querySelector('[data-pmc-popular-items]');
          const incomingButton = parsed.querySelector('[data-pmc-popular-load-more]');

          if (!incomingGrid || !currentGrid) throw new Error('Popular products response was incomplete');

          const incomingItems = Array.from(incomingGrid.children);
          currentGrid.append(...incomingItems);

          if (incomingButton && incomingButton.dataset.nextUrl) {
            button.dataset.nextUrl = incomingButton.dataset.nextUrl;
            button.dataset.loading = 'false';
            button.removeAttribute('aria-disabled');
            button.removeAttribute('aria-busy');
            button.classList.remove('is-loading');
            label.textContent = defaultLabel;
          } else {
            const firstIncomingLink = incomingItems[0] && incomingItems[0].querySelector('.pmc-popular-card__link');
            button.remove();
            if (firstIncomingLink) firstIncomingLink.focus();
          }

          if (status) {
            const statusTemplate = button.dataset.statusLabel || '';
            status.textContent = statusTemplate
              .replace('[shown]', String(currentGrid.children.length))
              .replace('[total]', this.dataset.totalProducts || String(currentGrid.children.length));
          }

          this.dispatchEvent(new CustomEvent('pmc:popular-products-loaded', {
            bubbles: true,
            detail: {
              shown: currentGrid.children.length,
              total: Number(this.dataset.totalProducts || currentGrid.children.length)
            }
          }));
        } catch (error) {
          button.dataset.loading = 'false';
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
          label.textContent = button.dataset.errorLabel;
          if (status) status.textContent = button.dataset.errorLabel;
          window.setTimeout(() => {
            if (button.isConnected && button.dataset.loading !== 'true') label.textContent = defaultLabel;
          }, 3200);
        }
      }
    }

    customElements.define('pmc-popular-products', PmcPopularProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmc-wiser-fallback-controller"]) return;
  try {
    
  (function () {
    'use strict';

    function parseRecentHandles() {
      try {
        var handles = JSON.parse(window.localStorage.getItem('recentlyViewed') || '[]');
        return Array.isArray(handles) ? handles.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function addRecommendationSurface(section) {
      if (!section) return;
      var collection = section.querySelector('.featured-collection');
      if (collection) {
        collection.classList.add('product-recommendations');
        collection.setAttribute('data-section-type', 'recommendations');
      }
    }

    function setRecentFallbackHeading(section) {
      if (!section) return;
      var title = section.querySelector('.heading-wrapper__heading .title, .heading-wrapper .title');
      var hasRecent = parseRecentHandles().length > 0;
      if (title) title.textContent = hasRecent ? 'Recently viewed' : 'Popular picks';
    }

    function hasRenderedProducts(container) {
      if (!container) return false;
      return Boolean(
        container.querySelector(
          'a[href*="/products/"], [data-product-id], [data-product-handle], iframe[src]'
        )
      );
    }

    function setupPair(appSelector, fallbackSuffix, isRecent) {
      var appInner = document.querySelector(appSelector);
      var appSection = appInner && appInner.closest('.shopify-section');
      var fallback = document.querySelector('[id$="' + fallbackSuffix + '"]');

      if (!fallback) return;

      addRecommendationSurface(fallback);
      if (isRecent) setRecentFallbackHeading(fallback);
      fallback.hidden = false;

      if (!appInner || !appSection) return;

      appSection.classList.add('pmc-wiser-probing');

      var settled = false;
      var observer;

      function sync() {
        if (settled || !hasRenderedProducts(appInner)) return;
        settled = true;
        appSection.classList.remove('pmc-wiser-probing');
        appSection.classList.add('pmc-wiser-ready');
        fallback.hidden = true;
        if (observer) observer.disconnect();
        window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
      }

      observer = new MutationObserver(sync);
      observer.observe(appInner, {
        childList: true,
        subtree: true,
        attributes: true
      });

      sync();
      [500, 1500, 3500, 7000, 12000].forEach(function (delay) {
        window.setTimeout(sync, delay);
      });

      window.setTimeout(function () {
        if (observer) observer.disconnect();
        if (!settled) appSection.classList.add('pmc-wiser-empty');
      }, 16000);
    }

    function start() {
      setupPair('.pmc-finder-wiser--ai', '__fallback_ai', false);
      setupPair('.pmc-finder-wiser--recent', '__native_recent', true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
